import style from "styled-components";

export const FormLogin = style.form`
  display: flex;
  flex-direction: column;
  height: auto;
  width: 40%;
  margin:40px;
  border:2px solid black;
  text-align:center;
  @media(max-width:800px){
    width:auto;
  }
`;

export const Input = style.input`
  background-color: ${({ theme }) => theme.colors.black};
  padding: 1.0rem;
  margin: 10px;
  height: auto;
  width:auto;
  font-size:1.5rem;
  text-align:center;
  &:focus {
    outline: none;
  }
`;

export const Warning = style.span`
  color:red;
`;

export const LoginRedirect = style.a`
 text-decoration:none;
 color:black;
 margin:1.0rem;
`;
